import type { FeatureCollection } from 'geojson';
import type * as MapGL from 'react-map-gl/mapbox';
import { proxy } from 'valtio';
import { getAntennaData } from '~/api/projects2';

interface AntennaMap {
  antennaSearchData: {
    success: boolean;
    data: FeatureCollection;
  };
  fccInfoData: {
    success: boolean;
    data: FeatureCollection;
  };
}

class Store {
  antennaMap: AntennaMap | null = null;
  map?: MapGL.MapRef = undefined;
  selectedObjectId: string | null = null;
  clickedCoordinates: { lat: number; lng: number } | null = null;

  async fetchAntennaMap(projectId: string) {
    const a = await getAntennaData(projectId);
    this.antennaMap = a;
  }

  setSelectedObjectId(objectId: string) {
    this.selectedObjectId = objectId;
  }

  setClickedCoordinates(coordinates: { lat: number; lng: number }) {
    this.clickedCoordinates = coordinates;
  }

  setCurrentMap(map?: MapGL.MapRef) {
    this.map = map;
  }

  resetCurrentMap() {
    this.map = undefined;
  }

  reset() {
    this.antennaMap = null;
    this.selectedObjectId = null;
    this.clickedCoordinates = null;
  }
}

const store = proxy(new Store());

export default store;
